<template>
  <div class="form-group" :class="{ 'has-error': errors.has(fieldId) }">
    <label>{{ label }}</label>
    <textarea :name="fieldId"
              :id="fieldId"
              :value="value"
              @input="updateValue($event.target.value)"
              :maxlength="maxlength"
              class="form-control"
              :class="cssClass"
              v-validate="validation"
              data-vv-value-path="value"
              data-vv-validate-on="input"></textarea>
    <p class="text-danger" v-if="errors.has(fieldId)">{{ errors.first(fieldId) }}</p>
  </div>
</template>
<script>
  export default {
    inject: ['$validator'],
    props: {
      value: {
        type: String
      },
      label: {
        type: String,
        required: true
      },
      cssClass: {
        type: String,
        required: false
      },
      fieldId: {
        type: String,
        required: true
      },
      maxlength: {
        type: Number,
        required: false,
        default() {
          return Number.MAX_VALUE;
        }
      },
      validation: {
        type: String
      },
      required: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/form/textAreaField.vue